<template>
  <div>
    <div class="app-content--inner p-0 page-add-obat">
      <page-title
        class="custom-breadcrumb"
        heading="Tambah Obat"
        :breadcrumb="[
          {
            label: 'Manajemen Obat & BHP',
            link: '/klinik/obat'
          },
          {
            label: 'Tambah Obat & BHP',
            active: true
          }
        ]"
      />
      <div class="container-fluid __zoom_out_obat">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-box mb-5">
              <div class="card-body p-5" style="padding-top:0px">
                <b-form @submit.prevent="submitinputObat">
                  <div class="row" v-if="satusehatAuthValid">
                    <div class="col-12 col-sm-11 mb-4">
                      <div class="row">
                        <div class="col-12 col-sm-6 pl-0">
                          <div class="outer-obat-tambah">
                            Apabila tidak mengisi KFA, maka data tidak akan sync
                            ke SatuSehat
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-row
                    v-for="(inputObat, index) in tmpInputObatData"
                    :key="inputObat.id"
                  >
                    <b-col
                      sm="11 outer-obat-tambah"
                      :class="{ 'mt-5': index > 0 }"
                    >
                      <b-row>
                        <b-col sm="6">
                          <!-- Kode Obat -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Kode Obat
                                <span style="color:red">*</span></label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                :value="inputObat.kode_layanan"
                                @change="
                                  onChangeValue({
                                    label: 'kode_layanan',
                                    index,
                                    $event
                                  })
                                "
                                @input="
                                  onInputKode(
                                    $event,
                                    index,
                                    inputObat,
                                    'kode_layanan'
                                  )
                                "
                                :state="
                                  errorState({ label: 'kode_layanan', index })
                                "
                                maxlength="10"
                                placeholder="input kode obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  inputObat.error &&
                                    (inputObat.error.kode_layanan.desc ==
                                    "kode layanan harus diisi"
                                      ? "Kode obat harus diisi"
                                      : inputObat.error.kode_layanan.desc)
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Kode KFA -->
                          <div class="row pb-3" v-if="satusehatAuthValid">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Kode KFA</label
                              >
                            </div>
                            <div class="col-md-7">
                              <vue-select
                                style="font-size:13px"
                                :options="optObatKfa"
                                @input="inputObatKfa($event, index)"
                                v-model="tmpInputObatData[index].obat_kfa"
                                class="form-select-tarif"
                                placeholder="Tulis kode KFA"
                                @search="debounceSearchObat"
                                :isClearable="true"
                                :keyOpt="'kode_kfa'"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                            <div class="col-md-2">
                              <b-button
                                @click="copyDataKfa(index)"
                                variant="primary"
                                :disabled="!tmpInputObatData[index].obat_kfa"
                                class="w-100 px-2"
                                style="font-size:12px"
                              >
                                <font-awesome-icon icon="clone" />
                                Copy
                              </b-button>
                            </div>
                          </div>

                          <!-- Nama Obat -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Nama Obat
                                <span style="color:red">*</span></label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                :value="inputObat.nama_layanan"
                                @change="
                                  onChangeValue({
                                    label: 'nama_layanan',
                                    index,
                                    $event
                                  })
                                "
                                @input="
                                  onInputNamaLayanan(
                                    $event,
                                    index,
                                    inputObat,
                                    'nama_layanan'
                                  )
                                "
                                :state="
                                  errorState({ label: 'nama_layanan', index })
                                "
                                maxlength="100"
                                placeholder="input nama obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  inputObat.error &&
                                    (inputObat.error.nama_layanan.desc ==
                                    "nama layanan harus diisi"
                                      ? "Nama obat harus diisi"
                                      : inputObat.error.nama_layanan.desc)
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- golongan obat -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Golongan Obat
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="tmpInputObatData[index].golongan_obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Kategori -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;">
                                Kategori Obat
                                <!-- <span style="color:red">*</span> -->
                                <!-- <font-awesome-icon
                                  v-tooltip="{
                                    content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui Kategori obat</span><br/>`
                                  }"
                                  class="tooltip-obat"
                                  icon="info-circle"
                                /> -->
                              </label>
                            </div>
                            <div class="col-md-9">
                              <!-- <vue-select
                                style="font-size:13px"
                                :options="optKategori"
                                @input="inputKategori($event, index)"
                                v-model="tmpInputObatData[index].kategori_obat"
                                class="form-select-tarif"
                                placeholder="pilih kategori"
                              /> -->
                              <b-form-input
                                disabled
                                :value="tmpInputObatData[index].kategori_obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                <!-- {{
                                  inputObat.error &&
                                    inputObat.error.kategori_obat_id.desc
                                }} -->
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Bentuk Sediaan -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Bentuk Sediaan
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="tmpInputObatData[index].bentuk_sediaan"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Satuan -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Satuan</label
                              >
                            </div>
                            <div class="col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optSatuan"
                                @input="inputSatuan($event, index)"
                                v-model="tmpInputObatData[index].satuan"
                                class="form-select-tarif"
                                placeholder="pilih satuan"
                              />
                            </div>
                            <b-form-invalid-feedback> </b-form-invalid-feedback>
                          </div>

                          <!-- Jenis -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;">
                                Jenis Obat
                                <span style="color:red">*</span>
                                <font-awesome-icon
                                  v-tooltip="{
                                    content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui jenis obat</span><br/>`
                                  }"
                                  class="tooltip-obat"
                                  icon="info-circle"
                                />
                              </label>
                            </div>
                            <div class="col-md-9">
                              <vue-select
                                style="font-size:13px;"
                                :options="optJenis"
                                @input="inputJenis($event, index)"
                                v-model="inputObat.jns_obat"
                                class="form-select-tarif"
                                placeholder="pilih jenis obat"
                              />
                              <b-form-invalid-feedback>
                                {{
                                  inputObat.error &&
                                    inputObat.error.jns_obat_id.desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Komposisi -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Komposisi
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="tmpInputObatData[index].komposisi"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Route -->
                          <div
                            class="row pb-3"
                            v-if="!tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-12 col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Route</label
                              >
                            </div>
                            <div class="col-12 col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optRoute"
                                @input="inputRoute($event, index)"
                                v-model="tmpInputObatData[index].route"
                                class="form-select-tarif"
                                placeholder="pilih Route"
                                :isClearable="true"
                                :disabled="tmpInputObatData[index].obat_kfa !== null"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Stok -->
                          <div
                            class="row pb-3"
                            v-if="!tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Stok Obat</label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                :value="inputObat.stok"
                                @change="
                                  onChangeValue({
                                    label: 'stok',
                                    index,
                                    $event
                                  })
                                "
                                v-on:keypress="NumbersOnly"
                                maxlength="100"
                                placeholder="input stok"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>
                        </b-col>

                        <b-col sm="6">
                          <!-- Route -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-12 col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Route</label
                              >
                            </div>
                            <div class="col-12 col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optRoute"
                                @input="inputRoute($event, index)"
                                v-model="tmpInputObatData[index].route"
                                class="form-select-tarif"
                                placeholder="pilih Route"
                                :isClearable="true"
                                :disabled="tmpInputObatData[index].obat_kfa !== null"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Manufactur -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Manufactur
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="tmpInputObatData[index].manufactur"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Stok -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Stok Obat</label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                :value="inputObat.stok"
                                @change="
                                  onChangeValue({
                                    label: 'stok',
                                    index,
                                    $event
                                  })
                                "
                                v-on:keypress="NumbersOnly"
                                maxlength="100"
                                placeholder="input stok"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Obat BPJS -->
                          <div class="row pb-3">
                            <div class="col-12 col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Obat BPJS</label
                              >
                            </div>
                            <div class="col-12 col-md-9">
                              <!-- @input="inputObatBpjs($event, index)" -->
                              <vue-select
                                style="font-size:13px"
                                :options="optObatBpjs"
                                v-model="tmpInputObatData[index].obat_bpjs"
                                class="form-select-tarif"
                                placeholder="pilih Obat BPJS"
                                :isClearable="true"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Het -->
                          <div
                            class="row pb-3"
                            v-if="tmpInputObatData[index].obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Het
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="tmpInputObatData[index].het"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Harga Beli -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Harga Beli</label
                              >
                            </div>
                            <div class="col-md-9">
                              <!-- v-model="hargaBeli[index]" -->
                              <!-- v-money="money_beli" -->
                              <!-- v-model="inputObat.harga_beli" -->
                              <b-form-input
                                v-on:keypress="NumbersOnly"
                                :value="format_money(inputObat.harga_beli)"
                                @input="onInputHargaBeli($event, index)"
                                :state="
                                  errorState({ label: 'harga_beli', index })
                                "
                                maxlength="19"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  inputObat.error &&
                                    inputObat.error.harga_beli.desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Margin -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Margin</label
                              >
                            </div>
                            <div class="col-md-9">
                              <!-- v-money="money_margin" -->
                              <!-- @input="onInputMargin($event, index)" -->
                              <b-form-input
                                :value="format_money(inputObat.margin)"
                                :state="errorState({ label: 'margin', index })"
                                maxlength="19"
                                disabled
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  inputObat.error && inputObat.error.margin.desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Harga Jual -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Harga Jual
                                <span style="color:red">*</span></label
                              >
                            </div>
                            <div class="col-md-9">
                              <!-- v-money="money" -->
                              <!-- v-model="inputObat.tarif" -->
                              <b-form-input
                                :value="format_money(inputObat.tarif)"
                                @input="inputObatLayanan($event, index)"
                                :state="errorState({ label: 'tarif', index })"
                                maxlength="19"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  inputObat.error && inputObat.error.tarif.desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Catatan -->
                          <div class="row pb-3" style="align-items:baseline;">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Catatan</label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-textarea
                                rows="4"
                                no-resize
                                v-model="inputObat.note"
                                @change="
                                  onChangeValue({
                                    label: 'note',
                                    index,
                                    $event
                                  })
                                "
                                placeholder="input catatan pendukung. Contoh: Masa berlaku obat 20 September 2025, pembelian batch 1."
                              ></b-form-textarea>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <!-- Action minus -->
                    <b-col sm="1" style="margin-top:125px;">
                      <div align="right">
                        <b-button
                          variant="danger"
                          :style="btnRemoveMobileStyle"
                          @click="removeinputObatData(index)"
                          v-if="index > 0"
                        >
                          <font-awesome-icon icon="minus" class="fa-sm" />
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="d-flex align-items-center ">
                    <b-col lg="11 p-0">
                      <div class="d-flex justify-content-center mt-4">
                        <b-button
                          variant="first"
                          class="mr-3"
                          style="padding: .5rem .8rem; border-radius: 100%"
                          @click="addinputObatData"
                        >
                          <font-awesome-icon icon="plus" />
                        </b-button>
                      </div>
                      <div align="right">
                        <b-button
                          class="text-capitalize mr-2"
                          variant="danger"
                          :to="{ path: '/klinik/obat' }"
                          >keluar</b-button
                        >
                        <b-button
                          class="text-capitalize"
                          type="submit"
                          variant="primary"
                          >simpan</b-button
                        >
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faMinus,
  faInfoCircle,
  faClone
} from "@fortawesome/free-solid-svg-icons";
import { mapGetters } from "vuex";
import { VMoney } from "v-money";
import debounce from "lodash/debounce";

library.add(faPlus, faMinus, faInfoCircle, faClone);

export default {
  directives: {
    money: VMoney
  },
  components: {
    "vue-select": () => import("@/components/VueSelect.vue")
  },
  data: () => ({
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "Rp",
      suffix: "",
      precision: 0
    },
    beingSubmit: false,
    errorKodeLayanan: null,
    errorsKodeLayanan: [],
    tmpInputObatData: [
      {
        status: true,
        jns_obat: null,
        jns_obat_id: null,
        kategori_obat: null,
        kategori_obat_id: null,
        nama_layanan: null,
        kode_layanan: null,
        tarif: 0,
        harga_beli: 0,
        margin: 0,
        selectedKelompok: "Obat",
        stok: null,
        satuan: null,
        satuan_id: null,
        note: null,
        obat_kfa: null,
        obat_kfa_id: null,
        golongan_obat: null,
        bentuk_sediaan: null,
        komposisi: null,
        route: null,
        manufactur: null,
        obat_bpjs: null,
        het: "-"
      }
    ],
    optKategori: [],
    optSatuan: [],
    optJenis: [],
    selectedKategori: null,
    selectedJenis: null,
    kodeContainer: [],
    namaContainer: [],
    beingSubmit: false,
    namaLayananContainer: [],
    kodeLayananContainer: [],
    errorKodeLayanan: null,
    errorsKodeLayanan: [],
    kodeLayananExistsInDb: [],
    namaLayananExistsInDb: [],
    optObatKfa: [],
    optRoute: [],
    optObatBpjs: ["Ya", "Tidak"]
  }),
  computed: {
    btnRemoveMobileStyle() {
      if (this.isMobile()) {
        return {
          padding: ".4rem .7rem",
          "border-radius": "100%",
          "margin-left": "-22px"
        };
      }

      return {
        padding: ".5rem .8rem",
        "border-radius": "100%",
        "margin-left": "-8px"
      };
    },
    ...mapGetters(["getKlinikId", "satusehatAuthValid"])
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  beforeMount() {
    this.tmpInputObatData = this.settmpInputObatData();
  },
  mounted() {
    this.getKategori();
    this.getJenis();
    this.getSatuan();
    this.getRoute();
  },
  methods: {
    format_money(value) {
      const { prefix, precision } = this.money;
      const formatter = new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      });

      return `${prefix}${formatter.format(value)}`;
    },
    inputRoute(data, index) {},
    copyDataKfa(index) {
      const item = this.tmpInputObatData[index];
      // console.log("sad");
      if (item.obat_kfa) {
        item.error.nama_layanan.error = null;
        item.error.nama_layanan.desc = "";
        item.nama_layanan = item.obat_kfa.name;
      } else {
        item.nama_layanan = "";
      }
    },
    inputObatKfa(data, index) {
      const item = this.tmpInputObatData[index];

      if (!item.obat_kfa) {
        item.obat_kfa_id = null;
        item.golongan_obat = null;
        item.kategori_obat = null;
        item.bentuk_sediaan = null;
        item.komposisi = null;
        item.manufactur = null;
        item.route = null;
        item.het = "-";
        return;
      }

      // console.log(this.tmpInputObatData[index].obat_kfa);

      const obat = item.obat_kfa;

      item.obat_kfa_id = obat.value;
      item.golongan_obat = obat.drug_clasification || '-';
      item.kategori_obat = obat.generik_label;
      item.bentuk_sediaan = obat.satuan;

      // 🔹 cari satuan dari optSatuan berdasarkan label
      const satuanMatch = this.optSatuan.find(
        s =>
          s.label &&
          item.bentuk_sediaan &&
          s.label.toLowerCase() === item.bentuk_sediaan.toLowerCase()
      );

      if (satuanMatch) {
        item.satuan = satuanMatch;
        item.satuan_id = satuanMatch.value;
      } else {
        item.satuan = null; // fallback kalau ga ketemu
        item.satuan_id = null;
      }

      item.komposisi = obat.komposisi ? obat.komposisi : "-";
      item.manufactur = obat.manufacturer;
      item.het = obat.het_price ? this.format_money(obat.het_price) : '-';

      if(obat.rute_pemberian){
        const rutePemberian = JSON.parse(obat.rute_pemberian);
        item.route = this.optRoute.find(route => route.code === rutePemberian.code);
      }

      // this.tmpInputObatData[index].jns_obat = this.tmpInputObatData[
      //   index
      // ].obat_kfa.type;
      // this.tmpInputObatData[index].het = this.format_money(
      //   this.tmpInputObatData[index].obat_kfa.het_price
      // );
      // if (this.tmpInputObatData[index].obat_kfa_id != null) {
      //   this.tmpInputObatData[index].error.obat_kfa_id.error = true;
      //   this.tmpInputObatData[index].error.obat_kfa_id.desc = "";
      // }
      // if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      // Vue.set(
      //   this.kodeLayananContainer,
      //   index,
      //   this.tmpInputObatData[index].obat_kfa_id
      // );
      // let isDuplicate = false;
      // let needDbChecks = [];
      // this.kodeLayananContainer.forEach((item, i) => {
      //   isDuplicate = false;
      //   this.kodeLayananContainer.forEach((item2, i2) => {
      //     if (i != i2) {
      //       if (item == item2 && item !== "") {
      //         this.tmpInputObatData[i].error["obat_kfa_id"].error = false;
      //         this.tmpInputObatData[i].error["obat_kfa_id"].desc =
      //           "Obat tidak boleh sama";
      //         isDuplicate = true;
      //       }
      //     }
      //   });
      //   if (isDuplicate == false) {
      //     this.tmpInputObatData[i].error["obat_kfa_id"].error = true;
      //     this.tmpInputObatData[i].error["obat_kfa_id"].desc = "";
      //     needDbChecks.push(i);
      //   }
      // });
      // if (needDbChecks.length > 0) {
      //   let newNeedDbChecks = [];
      //   needDbChecks.forEach(item => {
      //     let valDb = this.tmpInputObatData[item].obat_kfa_id;
      //     if (this.kodeLayananExistsInDb.indexOf(valDb) > -1) {
      //       this.tmpInputObatData[item].error["obat_kfa_id"].error = false;
      //       this.tmpInputObatData[item].error["obat_kfa_id"].desc =
      //         "Obat tidak boleh sama";
      //     } else newNeedDbChecks.push(item);
      //   });
      //   needDbChecks = newNeedDbChecks;
      //   needDbChecks.forEach(item => {
      //     this.$axios
      //       .post(
      //         `klinik/obat/cek?klinik_id=${this.getKlinikId}&kode_layanan=${this.tmpInputObatData[item].obat_kfa_id}`
      //       )
      //       .then(response => {
      //         if (response.data.status == false) {
      //           this.tmpInputObatData[item].error["obat_kfa_id"].error = false;
      //           this.tmpInputObatData[item].error["obat_kfa_id"].desc =
      //             "Obat tidak boleh sama";
      //         }
      //       })
      //       .catch(error => {});
      //   });
      // }
    },
    debounceSearchObat: debounce(function(val) {
      this.searchObat(val);
    }, 500),
    async searchObat(val) {
      if (val === "") return;

      try {
        const res = await this.$axios.get(
          `kfa/get-product?limit=25&value=${val}`
        );

        const { data, status } = res.data;

        if (status) {
          this.optObatKfa = data.map(res => ({
            ...res,
            label: `${res.kfa_code}-${res.name}`,
            value: res.id
          }));
        }
      } catch (err) {
        console.log(err);
      }
    },
    inputObatLayanan(data, index) {
      const item = this.tmpInputObatData[index];

      item.error.tarif.error = null;
      item.error.tarif.desc = "";

      // get only digits
      const numeric = this.parseMoney(data);

      // update data
      item.tarif = numeric;

      if (item.tarif < item.harga_beli) {
        item.margin = 0;
        item.error.tarif.error = false;
        item.error.tarif.desc = "Harga jual tidak boleh kurang dari harga beli";
      } else {
        item.margin = item.tarif - item.harga_beli;
      }

      // if (data != "Rp. 0") {
      //   this.tmpInputObatData[index].error.tarif.error = true;
      //   this.tmpInputObatData[index].error.tarif.desc = "";
      // } else if (
      //   this.tmpInputObatData[index].nama_layanan != null &&
      //   this.tmpInputObatData[index].kode_layanan != null &&
      //   data == "Rp. 0"
      // ) {
      //   this.tmpInputObatData[index].error.tarif.error = true;
      //   this.tmpInputObatData[index].error.tarif.desc = "";
      // }
    },
    parseMoney(value) {
      if (!value) return 0;
      // Hilangkan format "Rp. " dan tanda koma
      return parseFloat(value.replace(/[^\d]/g, "")) || 0;
    },
    onInputHargaBeli(event, index) {
      // get only digits
      const item = this.tmpInputObatData[index];

      item.error.tarif.error = null;
      item.error.tarif.desc = "";

      const numeric = this.parseMoney(event);

      // update data
      item.harga_beli = numeric;

      if (item.tarif < item.harga_beli) {
        item.margin = 0;
        item.error.tarif.error = false;
        item.error.tarif.desc = "Harga jual tidak boleh kurang dari harga beli";
      } else {
        item.margin = item.tarif - item.harga_beli;
      }
    },
    async getJenis() {
      try {
        const res = await this.$axios.get(`klinik/obat/jenis`);
        const { data, status } = res.data;
        if (status) {
          this.optJenis = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(`klinik/obat/kategori`);
        const { data, status } = res.data;
        if (status) {
          this.optKategori = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {}
    },
    async getRoute() {
      try {
        const res = await this.$axios.get(`kfa/route-obat`);
        const { data, status } = res.data;
        if (status) {
          this.optRoute = data.map(item => ({
            ...item,
            label: `${item.jenis_route} (${item.kategori})`,
            value: item.id
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    inputKategori(data, index) {
      this.tmpInputObatData[index].kategori_obat_id = this.tmpInputObatData[
        index
      ].kategori_obat.value;
      if (this.tmpInputObatData[index].kategori_obat_id != null) {
        this.tmpInputObatData[index].error.kategori_obat_id.error = true;
        this.tmpInputObatData[index].error.kategori_obat_id.desc = "";
      }
    },
    inputSatuan(data, index) {
      this.tmpInputObatData[index].satuan_id = this.tmpInputObatData[
        index
      ].satuan.value;
    },
    inputJenis(data, index) {
      this.tmpInputObatData[index].jns_obat_id = this.tmpInputObatData[
        index
      ].jns_obat.value;
      if (this.tmpInputObatData[index].jns_obat_id != null) {
        this.tmpInputObatData[index].error.jns_obat_id.error = true;
        this.tmpInputObatData[index].error.jns_obat_id.desc = "";
      }
    },
    settmpInputObatData() {
      return this.tmpInputObatData.map(item => {
        const tmp = Object.keys(item).reduce((obj, key) => {
          if (key !== "error") {
            obj[key] = this.generateErrorObj();
          }
          return obj;
        }, {});
        return {
          ...item,
          error: tmp
        };
      });
    },
    generateErrorObj() {
      return {
        error: null,
        desc: null
      };
    },
    errorState({ label, index }) {
      const { tmpInputObatData } = this;
      if (
        tmpInputObatData[index].error &&
        tmpInputObatData[index].error[label]
      ) {
        return tmpInputObatData[index].error[label].error;
      } else {
        return null;
      }
    },
    errorDesc({ label, index }) {
      const { tmpInputObatData } = this;
      if (
        tmpInputObatData[index].error &&
        tmpInputObatData[index].error[label]
      ) {
        return tmpInputObatData[index].error[label].desc;
      }
    },
    onKeyupTarif($event, index) {
      const { tmpInputObatData } = this;

      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    placeholderInput(label = "") {
      return startCase(`input ${label}`);
    },
    validateInput({ label, $event }) {
      return {
        error: ($event && true) || false,
        desc: (!$event && "kolom harus diisi") || ""
      };
    },
    validateAll() {
      const valItems = [
        "jns_obat_id",
        // "kategori_obat_id",
        "kode_layanan",
        "nama_layanan"
        // "tarif"
      ];

      this.tmpInputObatData.forEach(item => {
        valItems.forEach(valItem => {
          if (item.error[valItem].error == false) return;

          if (item[valItem] === null) {
            item.error[valItem].error = false;
            item.error[valItem].desc =
              valItem.replace("_", " ") + " harus diisi";
            if (
              item.error[valItem].desc == "kategori obat_id harus diisi" ||
              item.error[valItem].desc == "jns obat_id harus diisi"
            ) {
              let keynya = valItem.replace("_obat_id", " ");

              if (/kategori/.test(keynya)) {
                item.error[valItem].desc = "Kategori harus dipilih";
              } else {
                item.error[valItem].desc = "Jenis harus dipilih";
              }
            }
          } else {
            item.error[valItem].error = null;
            item.error[valItem].desc = "";
          }
        });
      });
    },
    submitinputObat() {
      const { tmpInputObatData, validateAll } = this;
      this.$nextTick(() => {
        validateAll();

        let isError = false;

        tmpInputObatData.forEach(tarifData => {
          for (let errIndex in tarifData.error) {
            if (tarifData.error[errIndex].error == false) {
              isError = true;
            }
          }
        });

        if (isError == false) {
          this.doSubmitinputObat();
        } else {
          this.$swal({
            type: "warning",
            text: "Silakan cek kembali pengisian data Anda!"
          });
        }
      });
    },
    async doSubmitinputObat() {
      const { constructPostData } = this;

      try {
        const res = await this.$axios.post(`klinik/obat`, {
          klinik_id: this.getKlinikId,
          arr: constructPostData()
        });
        const { status, data } = res.data;
        this.beingSubmit = true;
        if(status){
          this.$swal({
            title: "Tambah Data Berhasil",
            text: "Data berhasil tersimpan",
            type: "success",
            confirmButtonText: startCase("ya")
          });
          this.$router.push({ path: "/klinik/obat" });
        } else {
          this.$swal({
            title: "Gagal Menambahkan Data",
            type: "error",
          });
        }
      } catch (errror) {
        const x = errror.response.data;
        const y = Object.keys(x);
        y.map(item => {
          const z = item.split(".");
          this.tmpInputObatData[z[1]].error.nama_layanan.desc =
            x[item][x[item].length - x[item].length];
        });
        var d = errror.response.data.length;
      }
    },
    constructPostData() {
      const { tmpInputObatData } = this;
      const tmp = tmpInputObatData.map(item => {
        const x = Object.keys(item).filter(y => !["error"].includes(y));
        const z = x.reduce((obj, key) => {
          let q = key;

          // if (key == "tarif") {
          //   q = "tarif";
          //   // hapus separator ribuan dan jadikan int
          //   item[key] = parseInt(item[key].replace(/\D/g, ""));
          // }

          if (key == "stok") {
            if (item[key] != null) {
              item[key] = parseInt(item[key]);
            }
          }

          obj[q] = item[key];
          return obj;
        }, {});
        z.klinik_id = this.getKlinikId;
        return z;
      });
      return tmp;
    },
    onChangeValue({ index, label, $event }) {
      const { tmpInputObatData, validateInput } = this;
      const tmp = tmpInputObatData[index];
      if (tmp.error[label].error !== false) {
        tmp.error[label] = validateInput({
          label,
          $event
        });
      }
      if (label !== "tarif") {
        tmp[label] = $event;
        Vue.set(this.tmpInputObatData, index, tmp);
      }
    },
    onInputNamaLayanan(valRaw, index, o, p) {
      if (this._timeoutNamaLayanan) clearTimeout(this._timeoutNamaLayanan);
      let val = valRaw;
      Vue.set(o, p, valRaw);
      Vue.set(this.namaLayananContainer, index, val);

      if (!val) {
        this.tmpInputObatData[index].error["nama_layanan"].error = false;
        this.tmpInputObatData[index].error["nama_layanan"].desc =
          "Nama obat harus diisi";
        return;
      } else {
        this.tmpInputObatData[index].error["nama_layanan"].error = true;
        this.tmpInputObatData[index].error["nama_layanan"].desc = "";
      }
    },
    onInputKode(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      val = val.toUpperCase();
      Vue.set(o, p, val);
      Vue.set(this.kodeLayananContainer, index, val);

      if (val.match(/[^a-zA-Z0-9\-]+/) !== null) {
        this.tmpInputObatData[index].error["kode_layanan"].error = false;
        this.tmpInputObatData[index].error["kode_layanan"].desc =
          "Hanya bisa huruf, angka, dan -";
        return;
      }

      if (val.length == 0) {
        this.tmpInputObatData[index].error["kode_layanan"].error = false;
        this.tmpInputObatData[index].error["kode_layanan"].desc =
          "Kode obat harus diisi";
        return;
      }

      if (val.length < 3 && val.length > 0) {
        this.tmpInputObatData[index].error["kode_layanan"].error = false;
        this.tmpInputObatData[index].error["kode_layanan"].desc =
          "Kode obat minimal 3 karakter";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.kodeLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.kodeLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2 && item !== "") {
              this.tmpInputObatData[i].error["kode_layanan"].error = false;
              this.tmpInputObatData[i].error["kode_layanan"].desc =
                "Kode obat tidak boleh sama";

              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputObatData[i].error["kode_layanan"].error = true;
          this.tmpInputObatData[i].error["kode_layanan"].desc = "";

          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputObatData[item].kode_layanan;
          if (this.kodeLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputObatData[item].error["kode_layanan"].error = false;
            this.tmpInputObatData[item].error["kode_layanan"].desc =
              "Kode obat tidak boleh sama";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            this.$axios
              .post(
                `klinik/obat/cek?klinik_id=${this.getKlinikId}&kode_layanan=${this.tmpInputObatData[item].kode_layanan}`
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputObatData[item].error[
                    "kode_layanan"
                  ].error = false;
                  this.tmpInputObatData[item].error["kode_layanan"].desc =
                    "Kode obat tidak boleh sama";
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    addinputObatData() {
      const { tmpInputObatData, validateAll, generateErrorObj } = this;
      const lastIndex = tmpInputObatData[tmpInputObatData.length - 1];
      if (lastIndex === undefined) {
        this.tmpInputObatData.push({
          status: true,
          jns_obat: null,
          jns_obat_id: null,
          kategori_obat: null,
          kategori_obat_id: null,
          nama_layanan: null,
          kode_layanan: null,
          tarif: 0,
          harga_beli: 0,
          margin: 0,
          selectedKelompok: "Obat",
          stok: null,
          satuan: null,
          satuan_id: null,
          note: null,
          obat_kfa: null,
          obat_kfa_id: null,
          golongan_obat: null,
          bentuk_sediaan: null,
          komposisi: null,
          route: null,
          manufactur: null,
          obat_bpjs: null,
          het: "-"
        });
        this.tmpInputObatData = this.settmpInputObatData();
      } else {
        const x = Object.keys(lastIndex);
        let tmp = x.reduce((obj, key) => {
          if (key === "error") {
            obj[key] = x
              .filter(item => item !== "error")
              .reduce((obj, keyChild) => {
                obj[keyChild] = generateErrorObj();
                return obj;
              }, {});
          } else if (key === "id") {
            obj[key] = tmpInputObatData.length + 1;
          } else if (key == "status") {
            obj[key] = true;
          } else if (key == "selectedKelompok") {
            obj[key] = "Obat";
          } else {
            obj[key] = null;
          }
          return obj;
        }, {});
        validateAll();
        
        tmp = {
          ...tmp,
          tarif: 0,
          harga_beli: 0,
          margin: 0,
          obat_kfa: null,
          obat_kfa_id: null,
          golongan_obat: null,
          bentuk_sediaan: null,
          komposisi: null,
          route: null,
          manufactur: null,
          obat_bpjs: null,
          het: "-"
        };
        
        this.tmpInputObatData = [...tmpInputObatData, tmp];
      }
    },
    removeinputObatData(index) {
      const { tmpInputObatData } = this;
      const tmp = tmpInputObatData
        .slice(0, index)
        .concat(tmpInputObatData.slice(index + 1, tmpInputObatData.length));
      this.tmpInputObatData = tmp;

      // remap kodeLayananContainer
      this.kodeLayananContainer = tmp.map(item => {
        return item.kode_layanan;
      });
      this.namaLayananContainer = tmp.map(item => {
        return item.nama_layanan;
      });

      this.tmpInputObatData.forEach((v, i) => {
        if (v.kode_layanan != null && v.kode_layanan != "")
          this.onInputKode(v.kode_layanan, i, v, "kode_layanan");
        this.validateAll();
      });
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57)) ||
        charCode === 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss">
.__zoom_out_obat {
  zoom: 80%;
}

// .tooltip {
//   display: block !important;
//   z-index: 10000;
//   zoom: 80%;
// }

// .tooltip .tooltip-inner {
//   background: rgb(255, 255, 255);
//   color: black;
//   border-radius: 5px;
//   padding: 5px 10px 4px;
//   box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
//   border-style: solid;
// }

// .tooltip .tooltip-arrow {
//   height: 0;
//   border-style: solid;
//   position: absolute;
//   margin: 5px;
//   border-color: black;
// }

.outer-obat-tambah {
  position: relative;
  border-radius: 10px;
  border: 2px solid #bfbfbf;
  outline-color: #bfbfbf;
  padding: 15px;
  outline-width: thin;
}

.form-select-tarif
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
}

.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}

.page-add-obat {
  .vs__dropdown-option {
    white-space: wrap;
  }
  .vs--single .vs__selected {
    width: 90%;
  }

  .vs__selected-options {
    width: 80%;
  }

  .vs__selected-options .vs__selected {
    width: 87%;
  }

  .no-overflow {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .form-control {
    font-size: 13px;
    padding-left: 10px;
  }
}
</style>

<style lang="scss" scoped>
.form-inline label {
  display: -moz-box;
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: flex-start;
  margin-bottom: 0;
}

.invalid-feedback {
  // margin-left: 150px !important;
  min-height: 18px;
  display: block;
}
</style>
